/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IProcessSubTypeModalControllerScope extends controllers.IBaseModalControllerScope {
        createProcessDto: Wars.Domain.Model.Dtos.CreateProcessDto,
        userSelection: any;
        dropdownOptions: models.CodeDropDownItem[];
    }

    export class ProcessSubTypeModalController extends BaseModalController {

        constructor(
            private $scope: IProcessSubTypeModalControllerScope,
            createProcessDto: Wars.Domain.Model.Dtos.CreateProcessDto,
            userSelection: any,
            close: any)
        {
            super($scope, close);
            this.$scope.userSelection = userSelection;
            this.$scope.createProcessDto = createProcessDto;
        }

        public cancel(): void {
            this.$scope.dismissModal({ cancel: true, result: undefined });
        }
    }
}

warsApp.registerController("ProcessSubTypeModalController", ["$scope", "createProcessDto", "userSelection", "close"]);